module.exports = __webpack_public_path__ + "static/media/heather-ford-5gkYsrH_ebY-unsplash (2).14fda8e0.jpg";